<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;">
                    <h5 class="p-pt-4 p-d-flex p-jc-center">Esqueceu sua senha?</h5>
                    <p class="p-text-center">					
                        Digite seu endereço de e-mail e nós lhe enviaremos instruções sobre como redefinir sua senha.
                    </p>
                    <div class="p-field">					
                         <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="email" type="text" placeholder="Email" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="exibirErroEmail">Informe o email</small>                          
                        <div class="p-grid p-d-flex p-jc-between p-mt-1">
                            <div class="p-col-6 p-text-left">
                                <a href="#" @click="irLogin" class="text-help">Login</a> 
                            </div> 
                            <div class="p-col-6 p-text-right">                               
                            </div>                                                   
                        </div> 
                    </div>   
                    <div class="p-grid p-mb-4">
                        <div class="p-col-12">
                            <Button label="Enviar" @click="enviar"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="exibirErro">{{ mensagemErro }}</Message>
                    <Message severity="info" v-if="exibirSucesso">{{ mensagemSucesso }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import RevendedorService from '@/service/RevendedorService';

export default {
    revendedorService: null,
    data() {
        return {
            exibirSpin: false,
            exibirErroEmail: false,            
            mensagemErro: '',
            mensagemSucesso: '',
            exibirSucesso: false,
            exibirErro: false,
            email: '',
        }
    },    
    methods: {
        enviar() {
            this.exibirSpin = true;
            this.exibirErro = false;
            this.exibirErroEmail = false;       
            this.exibirSucesso = false;
            this.mensagemSucesso = '';
            this.mensagemErro = '';   
            if(this.email == '') {
                this.exibirErroEmail = true;
            }            
            if(!this.exibirErroEmail && !this.exibirErroSenha) {         
                let dados = {
                    email: this.email
                }   
                this.revendedorService.solicitarRedefinirSenha(dados)
                    .then(resp => {
                        this.exibirSpin = false;
                        this.exibirSucesso = true;
                        this.mensagemSucesso = resp.data.mensagem;
                    })
                    .catch(erro => {       
                        this.exibirSpin = false;                 
                        this.exibirErro = true;
                        if(erro.response.status == 400) {
                            this.mensagemErro = erro.response.data.mensagem;
                        } else {
                            this.mensagemErro = erro.response.data.mensagem;
                        }
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        irLogin() {
            this.$router.push('/login');
        }      
    },
    created() {
        this.revendedorService = new RevendedorService();       
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>